import { useNavigate } from "react-router-dom";
import { T } from "../../constants/theme";
import { useApi } from "../../hooks/useApi";
import ProductCard from "../../components/ProductCard";

export default function FeaturedProducts() {
  const navigate = useNavigate();
  const { data, loading } = useApi("/products?featured=true&limit=8");

  return (
    <section
      style={{
        background: T.paper,
        padding: "90px 0",
      }}
    >
      <div
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          padding: "0 32px",
        }}
      >
        {/* Section Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 60,
          }}
        >
          <span
            style={{
              color: T.gold,
              textTransform: "uppercase",
              letterSpacing: ".15em",
              fontWeight: 700,
              fontSize: 12,
            }}
          >
            Curated Selection
          </span>

          <h2
            style={{
              fontFamily: "'Georgia', serif",
              fontSize: 42,
              color: T.ink,
              margin: "12px 0",
              lineHeight: 1.1,
            }}
          >
            Featured Products
          </h2>

          <p
            style={{
              color: T.muted,
              fontSize: 16,
              maxWidth: 650,
              margin: "0 auto",
              lineHeight: 1.7,
            }}
          >
            Discover our handpicked selection of farm and garden essentials,
            chosen for quality you can rely on and results you can
            actually see.
          </p>

          <div
            style={{
              width: 70,
              height: 2,
              background: T.gold,
              margin: "24px auto 0",
            }}
          />
        </div>

        {/* Featured Products Grid */}
        {loading ? (
          <div
            style={{
              textAlign: "center",
              padding: "80px 0",
              color: T.muted,
              fontSize: 16,
            }}
          >
            Loading featured products...
          </div>
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(280px, 1fr))",
                gap: 28,
              }}
            >
              {(data?.data || []).map((p) => (
                <div
                  key={p.id}
                  style={{
                    transition: "all .35s ease",
                  }}
                >
                  <ProductCard
                    product={p}
                    onView={(slug) => navigate("/product/" + slug)}
                  />
                </div>
              ))}
            </div>

          {/* View All Button */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: 70,
  }}
>
  <button
    onClick={() => navigate("/shop")}
    style={{
      position: "relative",

      background:
        "linear-gradient(135deg, #111110 0%, #1C1B19 100%)",

      color: "#FFFFFF",

      border: "1px solid rgba(196,154,60,.35)",

      padding: "16px 42px",

      fontSize: 13,
      fontWeight: 700,

      letterSpacing: ".18em",
      textTransform: "uppercase",

      cursor: "pointer",

      transition: "all .3s ease",

      boxShadow: T.shadowSoft,

      display: "flex",
      alignItems: "center",
      gap: 12,
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform =
        "translateY(-3px)";

      e.currentTarget.style.boxShadow = T.shadowMedium;

      e.currentTarget.style.border =
        "1px solid rgba(196,154,60,.75)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform =
        "translateY(0)";

      e.currentTarget.style.boxShadow = T.shadowSoft;

      e.currentTarget.style.border =
        "1px solid rgba(196,154,60,.35)";
    }}
  >
    <span
      style={{
        color: "#C49A3C",
        fontSize: 11,
      }}
    >
      ✦
    </span>

    Explore Full Collection

    <span
      style={{
        transition: "transform .3s ease",
        color: "#C49A3C",
      }}
    >
      →
    </span>
  </button>
</div>
          </>
        )}
      </div>
    </section>
  );
}


